/**
 * Homepage - How It Works
 * Scroll-driven animation with IntersectionObserver
 */

(function () {
    'use strict';

    const STAGGER_MS = 150;

    function initHowItWorks(section) {
        const imageWrap = section.querySelector('.how-it-works__image-wrap');
        const line = section.querySelector('.how-it-works__line');
        const steps = section.querySelectorAll('.how-it-works__step');

        if (!steps.length) return;

        // ── Image: observe the whole section ────────────────────────
        const sectionObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Image zoom-in
                        if (imageWrap) imageWrap.classList.add('is-visible');

                        // Animate each step with stagger
                        steps.forEach((step, i) => {
                            const header = step.querySelector('.how-it-works__step-header');
                            const content = step.querySelector('.how-it-works__step-content');
                            const delay = 300 + i * STAGGER_MS;

                            setTimeout(() => {
                                if (header) header.classList.add('is-visible');
                                if (content) content.classList.add('is-visible');
                            }, delay);
                        });

                        // Draw the vertical line segments
                        const lines = section.querySelectorAll('.how-it-works__line-segment');
                        lines.forEach((line, i) => {
                            const delay = 300 + (i * STAGGER_MS) + (STAGGER_MS / 1.5);
                            setTimeout(() => line.classList.add('is-drawing'), delay);
                        });

                        sectionObserver.disconnect();
                    }
                });
            },
            {
                threshold: 0.15,
                rootMargin: '0px 0px -60px 0px',
            }
        );

        sectionObserver.observe(section);
    }

    function init() {
        document.querySelectorAll('.how-it-works').forEach(initHowItWorks);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Shopify section events (live preview in the editor)
    document.addEventListener('shopify:section:load', (e) => {
        const section = e.target.querySelector('.how-it-works');
        if (section) {
            // In the editor reset so animations trigger immediately
            const imageWrap = section.querySelector('.how-it-works__image-wrap');
            section.querySelectorAll('.how-it-works__step-header, .how-it-works__step-content').forEach(el => {
                el.classList.remove('is-visible');
            });
            section.querySelectorAll('.how-it-works__line-segment').forEach(line => {
                line.classList.remove('is-drawing');
            });
            if (imageWrap) imageWrap.classList.remove('is-visible');

            initHowItWorks(section);
        }
    });
})();
